/* eslint-disable react/react-in-jsx-scope */
import { datadogRum } from './utils/datadog'
import * as Sentry from "@sentry/react"
import './assets/AppTheme.css'
import { Amplify, Auth } from 'aws-amplify'
import AppStack from './navigation/AppStack'
import configuration from './Configuration'
import { useEffect } from 'react'
import {
  getProfile,
  getReApply,
  getTruelayerTerms,
} from './redux/Actions/getMethods'
import { useDispatch } from 'react-redux'
import { initializeApp } from "firebase/app"
import React from 'react'
import { getAnalytics, setUserId } from "firebase/analytics"
import checkIsUserLoggedIn from './navigation/checkIsUserLoggedIn'
import { clearStorageExceptLD } from './utils/clearStorage'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import TagManager from 'react-gtm-module'

Amplify.configure(configuration.awsExports)

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID
}

TagManager.initialize(tagManagerArgs)

export const silentLogout = async (ldClient) => {
  // Perform logout logic, silently
  const user = await checkIsUserLoggedIn()
  if (localStorage.getItem('login') || user === null) {
    const analytics = getAnalytics()
    setUserId(analytics, null)
    Auth.signOut()
    ldClient?.identify({
      kind: 'user',
      //key: uuidv4(),
      anonymous: true,
    })
    Sentry.setUser(null)
    datadogRum.clearUser()
    if (window.gtag) {
      window.gtag('set', {'user_id': null })
    }
    localStorage.removeItem('login')
    await window.Intercom('shutdown')
    await window.Intercom('boot', {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    })
    clearStorageExceptLD()
  }
}

export const handleLogout = async (ldClient) => {
  // Perform logout logic
  if (['', '/', '/introduction', '/about-you', '/error', '/decision', '/welcome', '/referred', '/end'].includes(window.location.pathname.toLowerCase())) {
    return
  }
  const user = await checkIsUserLoggedIn()
  if (localStorage.getItem('login') || user === null) {
    const analytics = getAnalytics()
    setUserId(analytics, null)
    Auth.signOut()
    ldClient?.identify({
      kind: 'user',
      //key: uuidv4(),
      anonymous: true,
    })
    Sentry.setUser(null)
    datadogRum.clearUser()
    if (window.gtag) {
      window.gtag('set', {'user_id': null })
    }
    localStorage.removeItem('login')
    window.location.href = '/'
    await window.Intercom('shutdown')
    await window.Intercom('boot', {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    })
    clearStorageExceptLD()
  }
}

function App() {
  const ldClient = useLDClient()
  
  const token = localStorage.getItem('login')

  const firebaseConfig = {
    apiKey: "AIzaSyDpejr0Yx-72hil9TO0nJMbZhcxoV75o8k",
    authDomain: "updraft-282b6.firebaseapp.com",
    projectId: "updraft-282b6",
    storageBucket: "updraft-282b6.appspot.com",
    messagingSenderId: "866229470694",
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  }
  // Initialize Firebase
  //const app = initializeApp(firebaseConfig)
  initializeApp(firebaseConfig)

  const dispatch = useDispatch()
  useEffect(() => {
    if (['/decision', '/welcome'].includes(window.location.pathname.toLowerCase())) {
      return
    }
    if (token) {
      dispatch(getTruelayerTerms())
      // dispatch(getApplications())
      dispatch(getProfile())
      dispatch(getReApply())
    }
  }, [token])

  useEffect(() => {
    let inactivityTimeout

    const resetInactivityTimeout = () => {
      // Clear the previous timeout and start a new one
      clearTimeout(inactivityTimeout)

      inactivityTimeout = setTimeout(
        () => {
          // Perform logout or any other action on inactivity timeout
          handleLogout(ldClient)
        },
        5 * 60 * 1000,
      ) // 5 minutes in milliseconds
    }

    const handleActivity = () => {
      resetInactivityTimeout()
    }

    // Attach event listeners for user activity
    window.addEventListener('mousemove', handleActivity)
    window.addEventListener('keydown', handleActivity)
    window.addEventListener('touchstart', handleActivity)

    // Set up initial inactivity timeout
    resetInactivityTimeout()

    // Detach event listeners and clear timeout on component unmount
    return () => {
      window.removeEventListener('mousemove', handleActivity)
      window.removeEventListener('keydown', handleActivity)
      window.removeEventListener('touchstart', handleActivity)
      clearTimeout(inactivityTimeout)
    }
  }, [])

  useEffect(() => {
    if (token === null) {
      handleLogout(ldClient)
    }
  }, [token === null])

  // TODO: put the following below wrapping the div I think:
  {/* <AnalyticsContext.Provider value={analytics}>*/}
  {/*</AnalyticsContext.Provider> */}
  return (
    <div>
      <AppStack />
    </div>
  )
}

export default App